import { Injectable } from '@angular/core';
import { ListService } from 'bookraw/shared/services/list.service';
import { SubscriptionPackage } from 'bookraw/shared/models/subscription.model';

@Injectable()
export class SubscriptionPackagesService extends ListService<SubscriptionPackage> {

  url: string = '/api/admin/packages';
}
